import { HttpParams } from '@angular/common/http';

import { Filter } from '../../../../models';
import { ArquivoReferencia } from '../../referencias';

/** Representa o Filter da pesquisa dos arquivos */
export class ArquivoFilter implements Filter {
    isFilterDirty = false;

    filterPsq: string;
    referencia: ArquivoReferencia;
    idReferencia: number;
    idsTiposArquivos: number[] = [];
    tipoArquivoNull = false;
    idsUsuariosCreated: number[] = [];
    idsUsuariosUpdated: number[] = [];
    idsUsuariosDeleted: number[] = [];

    constructor() {
        this.setDefaults();
    }

    private setDefaults() {
        //
    }

    /** Cria os parâmetros do filtro */
    createParams(params: HttpParams): HttpParams {
        if (!params) {
            params = new HttpParams();
        }

        // Filtro de Pesquisa
        if (this.filterPsq) {
            params = params.append('filterPsq', this.filterPsq);
        }

        // Referência
        if (this.referencia) {
            params = params.append('referencia', this.referencia.id.toString());
        }
        // ID Referência
        if (this.idReferencia) {
            params = params.append('idReferencia', this.idReferencia.toString());
        }

        // Tipos de arquivos
        this.idsTiposArquivos?.forEach(idTipoArquivo => {
            if (idTipoArquivo > 0) {
                params = params.append('idTipoArquivo', idTipoArquivo.toString());
            }
        });
        // Sem tipo de arquivo
        if (this.tipoArquivoNull) {
            params = params.append('tipoArquivoNull', 'true');
        }

        // Usuários created
        this.idsUsuariosCreated?.forEach(idUsuarioCreated => {
            params = params.append('idUsuarioCreated', idUsuarioCreated.toString());
        });

        // Usuários updated
        this.idsUsuariosUpdated?.forEach(idUsuarioUpdated => {
            params = params.append('idUsuarioUpdated', idUsuarioUpdated.toString());
        });

        // Usuários deleted
        this.idsUsuariosDeleted?.forEach(idUsuarioDeleted => {
            params = params.append('idUsuarioDeleted', idUsuarioDeleted.toString());
        });


        return params;
    }

    clear() {
        this.isFilterDirty = false;

        this.filterPsq = null;
        this.referencia = null;
        this.idReferencia = null;
        this.idsTiposArquivos = [];
        this.tipoArquivoNull = false;
        this.idsUsuariosCreated = [];
        this.idsUsuariosUpdated = [];
        this.idsUsuariosDeleted = [];

        this.setDefaults();
    }
}

